import { createContext, useContext } from 'react';

export const LandingMenuOpenContext = createContext(false);

export function useLandingMenuOpenContext(): boolean {
  return useContext(LandingMenuOpenContext);
}
